import useTranslation from "~/kernel/internationalization/useTranslation";
import describeTimeSince from "~/kernel/dateTime/describeTimeSince";
import { ReviewAuthorBadge } from "./ReviewAuthorBadge";
import type { CompanyPageReviewComment } from "~/routes/companies.$slug._index/CompanyPageReview";

type ReviewThreadProps = {
  comments: CompanyPageReviewComment[];
};

export function ReviewThread({ comments }: ReviewThreadProps) {
  if (comments.length < 1) {
    return null;
  }

  return (
    <ol className="divide-y divide-y-slate-200">
      {comments.map((comment) => (
        <li key={comment.id}>
          <ReviewComment comment={comment} />
        </li>
      ))}
    </ol>
  );
}

type ReviewCommentProps = { comment: CompanyPageReviewComment };

function ReviewComment({ comment }: ReviewCommentProps) {
  const { t, tt } = useTranslation("reviewsSection");

  return (
    <div className="space-y-1 py-3">
      <div className="flex flex-row flex-wrap gap-2 items-center">
        <span className="font-bold">
          {comment.authorName ?? tt("anonymous")}
        </span>
        <ReviewAuthorBadge author={comment.author} />
        <span className="text-slate-400">
          {describeTimeSince(comment.createdAt, { t })}
        </span>
      </div>
      <p>{comment.content}</p>
    </div>
  );
}
